import React from 'react';
import { useTranslation } from 'react-i18next';
import ReviewsOverlay from '../../Reviews';
import Omega3PlanSelector from '../../Omega3/components/Omega3PlanSelector';
import { OMEGA3_HERO_POINTS, OMEGA3_PLAN_KEYS } from '../../Omega3/data/omega3Data';
import useOmega3ReviewStats from '../../Omega3/hooks/useOmega3ReviewStats';

export const CUSTOM_FORMULA_OMEGA3_PLANS = [
  {
    id: OMEGA3_PLAN_KEYS.MONTHLY_SUBSCRIPTION,
    amount: 24.3,
    compareBaseAmount: 27,
    currency: 'EUR',
    duration: '1 month',
    quantity: 1,
    recurring: true,
    perMonthAmount: 24.3,
    titleKey: 'Omega3_Plan_Monthly_Title',
    badgeKey: 'Omega3_Plan_Monthly_Badge',
    quantityLabelKey: 'Omega3_Plan_Monthly_Quantity',
    ctaLabelKey: 'Omega3_Cta_Subscribe',
    detailKeys: [
      'Omega3_Plan_Monthly_Detail_1',
      'Omega3_Plan_Monthly_Detail_2',
      'Omega3_Plan_Monthly_Detail_3',
    ],
  },
  {
    id: OMEGA3_PLAN_KEYS.QUARTERLY_SUBSCRIPTION,
    amount: 64.8,
    compareBaseAmount: 81,
    currency: 'EUR',
    duration: '3 months',
    quantity: 3,
    recurring: true,
    perMonthAmount: 21.6,
    titleKey: 'Omega3_Plan_Quarterly_Title',
    badgeKey: 'Omega3_Plan_Quarterly_Badge',
    quantityLabelKey: 'Omega3_Plan_Quarterly_Quantity',
    ctaLabelKey: 'Omega3_Cta_Subscribe',
    detailKeys: [
      'Omega3_Plan_Quarterly_Detail_1',
      'Omega3_Plan_Quarterly_Detail_2',
      'Omega3_Plan_Quarterly_Detail_3',
    ],
  },
  {
    id: OMEGA3_PLAN_KEYS.ONE_MONTH_ONE_OFF,
    amount: 27,
    currency: 'EUR',
    duration: '30 days',
    quantity: 1,
    recurring: false,
    perMonthAmount: 27,
    titleKey: 'Omega3_Plan_OneOffMonthly_Title',
    badgeKey: 'Omega3_Plan_OneOffMonthly_Badge',
    quantityLabelKey: 'Omega3_Plan_OneOffMonthly_Quantity',
    ctaLabelKey: 'Omega3_Cta_BuyNow',
    detailKeys: [
      'Omega3_Plan_OneOffMonthly_Detail_1',
      'Omega3_Plan_OneOffMonthly_Detail_2',
      'Omega3_Plan_OneOffMonthly_Detail_3',
    ],
  },
  {
    id: OMEGA3_PLAN_KEYS.THREE_MONTH_ONE_OFF,
    amount: 81,
    currency: 'EUR',
    duration: '90 days',
    quantity: 3,
    recurring: false,
    perMonthAmount: 27,
    titleKey: 'Omega3_Plan_OneOffQuarterly_Title',
    badgeKey: 'Omega3_Plan_OneOffQuarterly_Badge',
    quantityLabelKey: 'Omega3_Plan_OneOffQuarterly_Quantity',
    ctaLabelKey: 'Omega3_Cta_BuyNow',
    detailKeys: [
      'Omega3_Plan_OneOffQuarterly_Detail_1',
      'Omega3_Plan_OneOffQuarterly_Detail_2',
      'Omega3_Plan_OneOffQuarterly_Detail_3',
    ],
  },
];

export const getCustomFormulaOmega3PlanByKey = (planKey) =>
  CUSTOM_FORMULA_OMEGA3_PLANS.find((plan) => plan.id === planKey) || CUSTOM_FORMULA_OMEGA3_PLANS[0];

export const getCustomFormulaOmega3PlanByDuration = (duration) =>
  CUSTOM_FORMULA_OMEGA3_PLANS.find((plan) => plan.duration === duration) || CUSTOM_FORMULA_OMEGA3_PLANS[0];

const CustomFormulaOmega3Purchase = ({
  selectedPlanKey,
  onSelectPlan,
  onCheckout,
  checkoutDisabled,
  reviewCount,
  reviewAverage,
  onReviewClick,
  metadata,
}) => {
  const { t } = useTranslation();
  const stats = useOmega3ReviewStats();
  const totalReviews = stats?.count ?? reviewCount ?? 0;
  const averageReviews = stats?.average ? parseFloat(stats.average).toFixed(1) : reviewAverage ?? 0;

  return (
    <div className="t-flex t-flex-col t-gap-[18px]">
      <h1
        className="!t-m-0 t-text-[32px] md:t-text-[40px] t-leading-[1.2] t-text-navy"
        style={{ fontFamily: 'DM Serif Display, serif' }}
      >
        {t('Omega3_Hero_Title')}
      </h1>
      <ReviewsOverlay
        totalReviews={totalReviews}
        averageReviews={averageReviews}
        onClick={onReviewClick}
        score={5}
      />
      {metadata}
      <p className="!t-m-0 t-leading-[1.7] t-text-sm lg:t-text-base t-text-g500">
        {t('Omega3_Hero_Subtitle')}
      </p>
      <div className="t-flex t-flex-col t-gap-3">
        {OMEGA3_HERO_POINTS.map((point) => (
          <div key={point.titleKey} className="t-flex t-items-start t-gap-3">
            <span className="t-text-xl t-leading-none t-mt-[2px] t-flex-none">{point.emoji}</span>
            <p className="!t-m-0 t-text-sm lg:t-text-base t-leading-[1.65] t-text-g500">
              <strong className="t-text-navy t-font-bold">{t(point.titleKey)}</strong>
              {' - '}
              {t(point.bodyKey)}
            </p>
          </div>
        ))}
      </div>
      <Omega3PlanSelector
        plans={CUSTOM_FORMULA_OMEGA3_PLANS}
        selectedPlanKey={selectedPlanKey}
        onSelect={onSelectPlan}
        onCheckout={onCheckout}
        checkoutDisabled={checkoutDisabled}
      />
    </div>
  );
};

export default CustomFormulaOmega3Purchase;
